var isNumber = require('../type/is-number');

var isDecimal = function isDecimal(num) {
  return isNumber(num) && num % 1 !== 0;
};

module.exports = isDecimal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-decimal.js
// module id = 295
// module chunks = 0 1 2